(function () {
  function sync(el) {
    var threshold = parseFloat(el.getAttribute('threshold')) || 0;
    var total = parseFloat(el.getAttribute('total-price')) || 0;
    var pct = threshold > 0 ? Math.min(100, (total / threshold) * 100) : 100;
    var track = el.querySelector('.ogal-shipbar-track');
    var fill = el.querySelector('.ogal-shipbar-fill');
    if (fill) fill.style.width = pct + '%';
    if (track) track.setAttribute('aria-valuenow', Math.round(pct));
  }
  function watch(el) {
    if (el.__ogalShipbarWatched) return;
    el.__ogalShipbarWatched = true;
    sync(el);
    new MutationObserver(function () { sync(el); }).observe(el, {
      attributes: true,
      attributeFilter: ['total-price', 'threshold']
    });
  }
  function scan() {
    document.querySelectorAll('free-shipping-bar').forEach(watch);
  }
  function start() {
    scan();
    document.addEventListener('cart:change', scan);
    // Prestige replaces the whole <free-shipping-bar> node (not just its
    // attributes) when the cart drawer re-renders, so watch the DOM itself
    // for new nodes instead of relying only on the cart:change timing.
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
          scan();
          break;
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
